import { render, staticRenderFns } from "./taskPreview.vue?vue&type=template&id=4ea8dcf0&scoped=true&"
import script from "./taskPreview.vue?vue&type=script&lang=js&"
export * from "./taskPreview.vue?vue&type=script&lang=js&"
import style0 from "./taskPreview.vue?vue&type=style&index=0&id=4ea8dcf0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8dcf0",
  null
  
)

export default component.exports